// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__Q3uM1","buttons":"Password_buttons__3ValT"};